import { useCallback, useState } from "react";

export default function useCardList() {
  const [cardOpen, setCardOpen] = useState();

  const viewCard = useCallback(value => setCardOpen(value), [setCardOpen]);
  const closeCard = useCallback(() => setCardOpen(false), []);

  return {
    cardOpen,
    setCardOpen,
    viewCard,
    closeCard
  };
}
